import {h} from 'preact';
import 'jquery-file-download';
import {useState} from "preact/hooks";
import util, {getDesignDimensions} from "../../util";
import MenuRoot from "./MenuRoot";
import MenuResize from "./MenuResize";
import MenuCopy from "./MenuCopy";
import MenuShare from "./MenuShare";
import MenuDownload from "./MenuDownload";
import MenuRevisions from "./MenuRevisions";
import MenuPublishChanges from './MenuPublishChanges';

export const MobileMenuRoutes = {
  root: 'root',
  resize: 'resize',
  copy: 'copy',
  download: 'download',
  publish: 'publish',
  publishChanges: 'publishChanges',
  revisions: 'revisions'
};

export default function MobileAppMenu({designId, designName, toggleMenu, designSize, isCustomSize, isSocialDesign, isLogo, isDigitalMenuBoard, isLogged, websiteToken, props, parentId, lastSavedTag, showPublishChanges, showPublishChangesDSA, showPublishWarningBanner}) {
  const [isCopyModal, setIsCopyModal] = useState(false);

  const [view, setView] = useState(MobileMenuRoutes.root);
  const [resizeData, setResizeData] = useState({});

  const {width, height, unit} = getDesignDimensions(props);

  function toRoot() {
    setResizeData({});
    setView(MobileMenuRoutes.root);
  }

  function onResizeCopy(size, width, height, unit) {
    setResizeData({size, width, height, unit});
    setView(MobileMenuRoutes.resize);
  }

  const size = util.sizes.filter(size => size.key === designSize)[0];
  const isA4 = size && size.key.indexOf('a4') > -1;

  return (
    <div className={'mob-main-menu'}>
      <div className={'mob-cover'} onClick={toggleMenu}/>

      <nav className={'slide-in-bottom'} onClick={ev => ev.stopPropagation()}>
        {view === MobileMenuRoutes.root &&
        <MenuRoot isLogged={isLogged} width={width} height={height} unit={unit} name={designName} setView={setView} toggleMenu={toggleMenu}
                  isSocialDesign={isSocialDesign} isDigitalMenuBoard={isDigitalMenuBoard} isCustomSize={isCustomSize} isLogo={isLogo} isA4={isA4} 
                  websiteToken={websiteToken} designName={designName} designId={designId} designSize={designSize} parentId={parentId} lastSavedTag={lastSavedTag}
                  showPublishChanges={showPublishChanges} showPublishChangesDSA={showPublishChangesDSA} showPublishWarningBanner={showPublishWarningBanner}/>}

        {view === MobileMenuRoutes.resize && <MenuResize width={width} height={height} unit={unit} toRoot={toRoot} toggleMenu={toggleMenu} onResizeCopy={onResizeCopy}/>}

        {view === MobileMenuRoutes.copy && <MenuCopy designId={designId} toRoot={toRoot} resizeData={resizeData}/>}

        {view === MobileMenuRoutes.publish && <MenuShare toRoot={toRoot} toggleMenu={toggleMenu}/>}

        {view === MobileMenuRoutes.publishChanges && <MenuPublishChanges toRoot={toRoot} showPublishWarningBanner={showPublishWarningBanner}/>}

        {view === MobileMenuRoutes.download && <MenuDownload toRoot={toRoot}/>}

        {view === MobileMenuRoutes.revisions && <MenuRevisions toRoot={toRoot} toggleMenu={toggleMenu}/>}
      </nav>
    </div>
  )
}
